export const AMZN_HEADERS = {
  'Content-Type': 'application/x-amz-json-1.1',
  'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
}
